import { AutogenLayoutlayout_dirembox } from "./autogen/AutogenLayoutlayout_dirembox";
import {  DataSourceExecutionEvent,  DataSourceMode,  DropdownSelectionEvent } from "@mcleod/components";
import { DropdownItem, Textbox } from "@mcleod/components";

export class layout_dirembox extends AutogenLayoutlayout_dirembox {

  private timer: any;

  override onLoad() {
    //console.log(this);
    this.UpdateTypes();
    clearInterval(this.timer);
    this.timer = setInterval(() => this.GetNewBoxID(), 250);
  }

  async GetNewBoxID()
  {
    clearInterval(this.timer);
    this.timer = null;
    this.tbRmbxId.enabled = false;
    //let rmbxid=0, prmbxid=0;
    //   if( this.sourceDirembox.mode == "add" )
    //   {   //Adding a new record
    //     await this.sourceDirembox2.search( { rmbx_id: ">0" } );
    //     for( let i=0; i < this.sourceDirembox2.rowCount; i++ )
    //     {
    //         this.sourceDirembox2.rowIndex = i;
    //         rmbxid = this.sourceDirembox2.activeRow.data.rmbx_id;
    //         if( rmbxid > prmbxid )
    //             prmbxid = rmbxid;
    //     }
    //     if( prmbxid > 0 )
    //     {
    //         prmbxid += 1;
    //         this.tbRmbxId.text = prmbxid.toString();
    //     }
    //   }
    }

  UpdateTypes()
  {
    const items: DropdownItem[] = [];
    //items.push({ caption: "Both", value: "B" } );
    //items.push({ caption: "Inbox", value: "I" } );
    //items.push({ caption: "Outbox", value: "O" } );
    items.push(new DropdownItem("B", "Both"));
    items.push(new DropdownItem("I", "Inbox"));
    items.push(new DropdownItem("O", "Outbox"));
    this.textboxRmbxType.items = items;
  }

  /** This is an event handler for the afterExecution event of sourceDidbalias. */
  sourceDidbaliasAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = this.sourceDidbalias.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.didb_desc, value: row._data.didb_dbalias });
        items.push(new DropdownItem(row._data.didb_dbalias, row._data.didb_desc));
    }
    this.textboxRmbxDba.items = items;
  }

/** This is an event handler for the afterExecution event of sourceImgApps. */
  sourceImgAppsAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = this.sourceImgApps.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        let appname: string = row._data.imap_appname;
        appname = appname.replace( "&", "" );
        //items.push({ caption: appname, value: row._data.imap_appid });
        items.push(new DropdownItem(row._data.imap_appid, appname));
    }
    this.textboxRmbxAppid.items = items;
  }

}
